(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-combo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('combo-banner')) {
  customElements.define('combo-banner', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.auto !== 'true' || this.reduced.matches;
      const controls = this.querySelector('[data-controls]');
      if (!controls) return;
      controls.hidden = false;
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1), options);
      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.paused = true; this.show(i); this.schedule(); }, options));
      this.querySelector('[data-pause]')?.addEventListener('click', () => { this.paused = !this.paused; this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); }, options);
      this.addEventListener('focusin', event => { if (!this.contains(event.relatedTarget)) { this.paused = true; this.schedule(); } }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.paused = true; this.schedule(); }, options);
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.paused = true; this.show(index); this.schedule(); }
      }, options);
      this.schedule();
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller?.abort(); }
    show(index) {
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === this.index)));
    }
    move(direction) { this.paused = true; this.show(this.index + direction); this.schedule(); }
    schedule() {
      clearTimeout(this.timer);
      const pause = this.querySelector('[data-pause]');
      if (pause) { pause.textContent = this.paused ? 'Play' : 'Pause'; pause.setAttribute('aria-label', this.paused ? 'Play slideshow' : 'Pause slideshow'); }
      if (this.paused || this.hovering || document.hidden || this.slides.length < 2) return;
      this.timer = setTimeout(() => { this.show(this.index + 1); this.schedule(); }, Number(this.dataset.seconds || 5) * 1000);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video"] && !Shopify.designMode) return;
  try {
    
class KsShoppableVideos extends HTMLElement {
  constructor () {
    super()
    
    this.slider = null
    this.initializationAttempts = 0
    this.maxAttempts = 10
    
    this.loadSwiperAndInitialize()
    this.setupVideoEvents()
  }

  async loadSwiperAndInitialize() {
    try {
      await this.ensureSwiperLoaded()
      await this.initializeSlider()
    } catch (error) {
      console.error('Failed to initialize Swiper slider:', error)
      // Fallback: show content without slider functionality
      this.showFallbackContent()
    }
  }

  ensureSwiperLoaded() {
    return new Promise((resolve, reject) => {
      // Check if Swiper is already available
      if (window.Swiper) {
        resolve()
        return
      }

      // Check if script is already being loaded
      let existingScript = document.querySelector('#swiper-script')
      
      if (!existingScript) {
        // Create and load the script
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js')
        script.setAttribute('id', 'swiper-script')
        
        script.onload = () => {
          // Wait a bit more for Swiper to be fully available
          setTimeout(() => {
            if (window.Swiper) {
              resolve()
            } else {
              reject(new Error('Swiper not available after loading'))
            }
          }, 100)
        }
        
        script.onerror = () => {
          reject(new Error('Failed to load Swiper script'))
        }
        
        document.head.appendChild(script)
      } else {
        // Script exists, wait for it to load
        this.waitForSwiper(resolve, reject)
      }
    })
  }

  waitForSwiper(resolve, reject) {
    const checkSwiper = () => {
      this.initializationAttempts++
      
      if (window.Swiper) {
        resolve()
      } else if (this.initializationAttempts >= this.maxAttempts) {
        reject(new Error('Swiper loading timeout'))
      } else {
        setTimeout(checkSwiper, 200)
      }
    }
    
    checkSwiper()
  }

  async initializeSlider() {
    const swiperElement = this.querySelector('.swiper')
    if (!swiperElement) {
      throw new Error('Swiper element not found')
    }

    // Initialize Swiper
    this.slider = new window.Swiper(swiperElement, this.splideOptions())

    // Setup event listeners
    this.slider.on('slideChange', () => {
      swiperElement.classList.add('swiper-is-changing')
      this.onSlideChange()
    })

    this.slider.on('slideChangeTransitionEnd', () => {
      swiperElement.classList.remove('swiper-is-changing')
    })

    // Mark as initialized
    swiperElement.classList.add('swiper-initialized')
  }

  showFallbackContent() {
    // Show the slider content even if Swiper fails to load
    const swiperElement = this.querySelector('.swiper')
    if (swiperElement) {
      swiperElement.style.opacity = '1'
      swiperElement.classList.add('swiper-fallback')
      
      // Hide navigation elements since they won't work
      const nav = this.querySelectorAll('.swiper-button-prev, .swiper-button-next, .swiper-pagination, .swiper-scrollbar')
      nav.forEach(el => el.style.display = 'none')
    }
  }

  setupVideoEvents() {
    this.querySelectorAll('.ks-shoppable-videos-btn-play').forEach(btn => {
      btn.addEventListener('click', () => {
        const video = btn.closest('.ks-shoppable-videos-video-wrapper').querySelector('video')
        this.onVideoPlay(video)
      })
    })
    
    this.querySelectorAll('video').forEach(video => {
      video.addEventListener('click', () => {
        this.onVideoPlay(video)
      })
    })
  }

  splideOptions() {
    const partialSlidesMobile = this.dataset.partialSlidesMobile === 'true' ? 1.2 : 1

    return {
      rewind: true,
      speed: Number(this.dataset.sliderSpeed),
      breakpoints: {
        0: { slidesPerView: Number(this.dataset.breakpointXs) * partialSlidesMobile },
        576: { slidesPerView: Number(this.dataset.breakpointSm) },
        768: { slidesPerView: Number(this.dataset.breakpointMd) },
        992: { slidesPerView: Number(this.dataset.breakpointLg) },
        1200: { slidesPerView: Number(this.dataset.breakpointXl) },
        1400: { slidesPerView: Number(this.dataset.breakpointXxl) }
      },
      navigation: {
        enabled: this.dataset.sliderNav === 'true',
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      },
      pagination: {
        enabled: this.dataset.sliderPagination === 'true',
        type: this.dataset.sliderPaginationType,
        el: '.swiper-pagination',
        dynamicBullets: true,
        dynamicMainBullets: 2,
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`
        }
      },
      scrollbar: {
        enabled: this.dataset.sliderScrollbar === 'true',
        el: this.querySelector('.swiper-scrollbar'),
        draggable: true
      },
      autoplay: this.dataset.sliderAutoplay !== '0'
        ? { delay: Number(this.dataset.sliderAutoplay) * 1000 }
        : undefined,
      watchSlidesProgress: true,
      mousewheel: {
        enabled: true,
        forceToAxis: true
      }
    }
  }

  onSlideChange() {
    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      elem.setAttribute('data-is-playing', 'false')
      elem.querySelector('video')?.pause()
    })
  }

  onVideoPlay(video) {
    const card = video.closest('.ks-shoppable-videos-card')

    this.querySelectorAll('.ks-shoppable-videos-card').forEach(elem => {
      if (elem.dataset.index !== card.dataset.index) {
        elem.setAttribute('data-is-playing', 'false')
        elem.querySelector('video')?.pause()
      }
    })
    
    if (card.dataset.isPlaying === 'true') {
      card.setAttribute('data-is-playing', 'false')
      video.pause()
    } else {
      card.setAttribute('data-is-playing', 'true')
      video.muted = false
      video.play()
    }
  }
}

customElements.define('ks-shoppable-videos', KsShoppableVideos)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('prayer-reviews')) customElements.define('prayer-reviews', class extends HTMLElement {
 connectedCallback() {
  this.cleanup?.();
  const abort = new AbortController(), options = {signal:abort.signal};
  const track = this.querySelector('.prayer__track');
  track.querySelectorAll('[data-loop-copy]').forEach(el=>el.remove());
  const originals = [...track.querySelectorAll('[data-card]')];
  const dots = [...this.querySelectorAll('[data-dot]')];
  const output = this.querySelector('[data-position]');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const count = originals.length, looping = count > 1;
  let playing = this.dataset.autoplay === 'true' && !reduced.matches;
  let frame = 0, period = 0, origin = 0, current = 0, last = 0, remainder = 0;
  let hover = false, focused = false, touching = false, visible = true, resumeAt = 0;
  const speed = Math.max(10, Math.min(200, Number(this.dataset.speed) || 60));
  track.classList.toggle('prayer__track--loop', looping);
  const copy = card => {
   const el=card.cloneNode(true);el.dataset.loopCopy='';el.setAttribute('aria-hidden','true');
   for(const node of [el,...el.querySelectorAll('*')]) {
    node.removeAttribute('id');node.removeAttribute('data-shopify-editor-block');
    if(node.matches('a,button,input,select,textarea,[tabindex]'))node.setAttribute('tabindex','-1');
   }
   return el;
  };
  if(looping) {
   const before=document.createDocumentFragment(),after=document.createDocumentFragment();
   for(let n=0;n<3;n++){originals.forEach(c=>before.append(copy(c)));originals.forEach(c=>after.append(copy(c)));}
   track.prepend(before);track.append(after);
  }
  const mod=(x,n)=>((x%n)+n)%n;
  const update = () => {
   if(!count)return;
   const step = looping ? period/count : originals[0].getBoundingClientRect().width;
   current=looping?mod(Math.round((track.scrollLeft-origin)/step),count):0;
   dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===current)));
  };
  const normalize = () => {
   if(!looping||!period)return;
   const relative=track.scrollLeft-origin;
   if(relative<0||relative>=period) track.scrollLeft=origin+mod(relative,period);
  };
  const measure = () => {
   const pad=parseFloat(getComputedStyle(track).paddingLeft);
   origin=originals[0]?originals[0].offsetLeft-pad:0;
   period=looping?track.querySelector('[data-loop-copy]:last-child').offsetLeft:0;
   if(looping)period=originals[originals.length-1].nextElementSibling.offsetLeft-originals[0].offsetLeft;
   track.scrollLeft=origin+(looping?current*period/count:0);remainder=0;update();
  };
  const rest=()=>{resumeAt=performance.now()+(Number(this.dataset.resume)||3)*1000;remainder=0;};
  const go=index=>{
   if(!looping)return;rest();
   track.scrollLeft=origin+mod(index,count)*period/count;update();
   output.textContent=(current+1)+' / '+count;
  };
  dots.forEach((dot,i)=>dot.addEventListener('click',()=>go(i),options));
  track.addEventListener('scroll',()=>{if(!touching&&!focused)normalize();update();},{...options,passive:true});
  this.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse')hover=true;},options);
  this.addEventListener('pointerleave',()=>{hover=false;rest();},options);
  this.addEventListener('pointerdown',()=>{touching=true;rest();},options);
  const release=()=>{if(touching){touching=false;rest();}};
  window.addEventListener('pointerup',release,options);window.addEventListener('pointercancel',release,options);
  this.addEventListener('wheel',rest,{...options,passive:true});
  this.addEventListener('focusin',e=>{focused=track.contains(e.target);rest();},options);
  this.addEventListener('focusout',()=>{focused=false;rest();},options);
  track.addEventListener('keydown',e=>{
   if(e.target!==track)return;
   if(['ArrowRight','ArrowLeft','Home','End'].includes(e.key)){
    e.preventDefault();go(e.key==='Home'?0:e.key==='End'?count-1:current+(e.key==='ArrowRight'?1:-1));
   }
  },options);
  document.addEventListener('shopify:block:select',e=>{
   const card=e.target.closest('[data-card]');const index=originals.indexOf(card);
   if(index>=0){go(index);focused=true;}
  },options);
  document.addEventListener('shopify:block:deselect',()=>{focused=false;rest();},options);
  reduced.addEventListener('change',()=>{playing=this.dataset.autoplay==='true'&&!reduced.matches;},options);
  const intersection=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;last=0;});intersection.observe(this);
  const resize=new ResizeObserver(measure);resize.observe(track);
  const tick=time=>{
   const elapsed=last?Math.min(time-last,64):0;last=time;
   if(looping&&period&&playing&&visible&&!document.hidden&&!hover&&!focused&&!touching&&time>=resumeAt){
    const velocity=this.dataset.timing==='seconds'?period/count/Math.max(2,Number(this.dataset.seconds)||6):speed;
    remainder+=elapsed*velocity/1000;
    const pixels=Math.floor(remainder);
    if(pixels){remainder-=pixels;track.scrollLeft+=pixels;normalize();update();}
   }
   frame=requestAnimationFrame(tick);
  };
  measure();frame=requestAnimationFrame(tick);
  this.cleanup=()=>{abort.abort();resize.disconnect();intersection.disconnect();cancelAnimationFrame(frame);track.querySelectorAll('[data-loop-copy]').forEach(el=>el.remove());};
 }
 disconnectedCallback(){this.cleanup?.();}
});


  } catch(e) { console.error(e); }
})();
})();
